import React, { useEffect } from "react";
import { StateManager } from "./PartyState";
import { LikesButton, LikesButtonProps } from "./LikesButton";
import { useIntervalWhen } from "rooks";
import { ChatConfigData, MessageConfigData } from "../Shared/Party/PartyConfigData";
import { StateManagerContext } from "./StateManagerContext";
import { FeedPosition, MessagePositionFunctionNotifier, UIConfigContext, UserMessageHandler } from "./UIConfigContext";
import { EventDrivenOverlayViewEvent } from "./Party";






export type LiveMessageFeedProps = {
    chatId: string;
    chat: ChatConfigData;
    height: number;
    currentUser: string;
    captureUserMessage?: boolean;
}

const getTotalHeight = (messages: JSX.Element[]): number => {
    var totalHeight = 0;
    for (let i = 0; i < messages.length; i++) {
        const key = messages[i].key;
        if (key !== null) {
            const element = document.getElementById(key);
            const rect = element?.getBoundingClientRect();
            if ((rect !== null) && (rect !== undefined)) {
                totalHeight += rect.height;
            }
        }
    }
    return totalHeight;
}

const getTranslationsFor = (messages: MessageConfigData[], panelHeight: number): number[] => {
    const ret = new Array<number>();
    const heights = new Array<number>();
    var totalHeight = 0;
    for (let i = 0; i < messages.length; i++) {
        const element = document.getElementById("LiveMessageFeed-Div-" + messages[i].itemId);
        const rect = element?.getBoundingClientRect();
        if ((rect !== null) && (rect !== undefined)) {
            heights.push(rect.height);
            totalHeight += rect.height;
            //console.log('getTranslations => i : ' + i + ' height : ' + rect.height);
        }
        //else
        //console.log('getTranslations => i : ' + i + ' height : null or undefined');
    }

    var top = 0;
    for (let i = 0; i < heights.length; i++) {
        ret.push(top);
        totalHeight -= heights[i];
        if (totalHeight <= panelHeight)
            i = heights.length;
        top += heights[i];
    }


    return ret;
}

const firstMessageOffscreen = (tops: number[], height: number, offset: number): number => {
    const bottom = height + offset;
    for (let i = 1; i < tops.length; i++) {
        if (i == (tops.length - 1))
            return i - 2;
        else if (tops[i] > bottom)
            return i - 1;
    }
    return -1;
}

export const RenderMessageForFeed = (message: MessageConfigData, background: string, fontBase: number, currentUser: string, index: number, showEventOverlay: (eventType: EventDrivenOverlayViewEvent, data: { [key: string]: string }) => void): JSX.Element => {
    const isOwnMessage = message.userId === currentUser;
    const likesProps: LikesButtonProps = {
        width: 70,
        height: 70,
        background: background,
        fontBase: fontBase,
        voting: message.voting,
        unlike: true,
        matchExpression: true,
        format: 'column',
    }

    const nickname = isOwnMessage ? "@me " : ((message.nickname[0] === '@' ? '' : '@') + message.nickname + " ");
    const outerId = "LiveFeedMessageOuterDiv" + index;
    const ret = (
        <div style={{
            display: "grid",
            gridTemplateColumns: "70px auto",
            gridTemplateRows: "auto",

        }}
            id={outerId}
            key={outerId}
        >
            <div style={{ gridRow: "1", gridColumn: "1" }}>
                <LikesButton {...likesProps} key={message.voting.itemId} />
                {/*key={"LiveMessageFeed-Votes-" + messages[i].itemId} />*/}
            </div>
            <div style={{
                gridColumn: "2",
                gridRow: "1",
                fontSize: fontBase + "px",
                textAlign: "left",
                paddingLeft: "5px",
                paddingRight: "5px",
                paddingTop: "5px",
                paddingBottom: "10px"

            }}
                key={"LiveMessageFeed-Typography-" + message.itemId}>
                <span style={{
                    color: message.userColor
                }} key={"LiveMessageFeed-Typography-Nickname-" + message.itemId} onClick={() => {
                    if (nickname !== '@me')
                        showEventOverlay('showProfile', { nickname: nickname });
                }}>{nickname}</span>
                <span style={{
                    color: "white"
                }} key={"LiveMessageFeed-Typography-BodyText-" + message.itemId}>{message.bodyText}</span>

            </div>


        </div>
    );
    return ret;
}

/*const renderMessages = (chat: ChatConfigData, background: string, fontBase: number, currentUser: string, showSignIn: () => void): Array<JSX.Element> => {
    const ret = new Array<React.ReactElement>();
    for (var i = 0; i < chat.messages.length; i++) {
        ret.push(renderMessageFeedPanel(chat.messages[i], background, fontBase, currentUser, i, showSignIn));
    }
    return ret;

}*/

export const getChat = (m: StateManager, id: string): ChatConfigData => {
    if (m.main().chat?.itemId === id) {
        const c = m.main().chat;
        if (c !== undefined)
            return c;
    }
    return m.context().chats[id];
}



export const LiveMessageFeed = ({ chatId, chat, height, currentUser, captureUserMessage }: LiveMessageFeedProps) => {

    const uiConfig = React.useContext(UIConfigContext);
    const stateManager = React.useContext(StateManagerContext);
    const messageIndex = React.useRef<number>(0);
    const messageListId = React.useRef<string>('');

    const messageComponents = React.useRef<Array<JSX.Element>>(new Array<JSX.Element>());
    const stackElementRef = React.createRef<HTMLDivElement>();
    const atBottom = React.useRef<boolean>();
    const showNext = React.useRef<number>(Date.now() + 1000);
    const initFuncs = React.useRef<boolean>(false);

    const messageTranslations = React.useRef<number[]>([]);
    const currentOffset = React.useRef<number>(0);


    const tickCounter = React.useRef<number>(0);
    const tickLimit = React.useRef<number>(60);

    const rcRef = React.useRef<number>(0);

    const [rc, setRc] = React.useState<number>(0);
    const chatIdRef = React.useRef<string>(chatId);
    const chatConfigRef = React.useRef<ChatConfigData>(chat.itemId !== '' ? chat : getChat(stateManager, chatId));
    const forceRender = React.useRef<boolean>(false);


    /* if (chatIdRef.current !== chatId) {
         stateManager.ui().liveFeedTimings[chatIdRef.current] = undefined;
         chatIdRef.current = chatId;
         chatConfigRef.current = chat !== undefined ? chat : getChat(stateManager, chatId);
     }*/

    const messagePositionNotifier = (): FeedPosition => {
        //const next = firstMessageOffscreen(messageTranslations.current, height, currentOffset.current);
        return {
            top: messageIndex.current,
            bottom: messageIndex.current,
            next: messageIndex.current + 1
        }
    }



    const userMessageHandler = (userMessage: MessageConfigData) => {
        console.log("LiveMessageFeed: User message call back");
        //forceRender.current = true;
        //tickCounter.current = 15;
        //messageTranslations.current = [];
        //setRc(rc + 1);
        //const timings = stateManager.ui().liveFeedTimings[chatIdRef.current]
        /*if (timings !== undefined) {
            const at = messageIndex.current + 1;
            if (at < timings.length) {
                timings.splice(at, 0, (at === 0 ? 0 : timings[at - 1]) + 3);
                for (let a = at + 1; a < timings.length; a++)
                    timings[a] += 3;
            }
            else
                timings.push(timings[timings.length - 1] + 3);
        }*/
        showNext.current = Date.now() + 2000;
    }


    if (!initFuncs.current) {
        initFuncs.current = true;

        if (captureUserMessage === true)
            uiConfig.setUserMessageHandler(userMessageHandler);

        uiConfig.messagePositionNotifier(messagePositionNotifier);

        if (stateManager.ui().liveFeedTimings[chatIdRef.current] !== undefined) {

            const fromState = stateManager.ui().liveFeedTimings[chatIdRef.current];
            if (fromState.at < chatConfigRef.current.endTime) {
                messageIndex.current = fromState.index;

            }

            /*var totalTime = Date.now();
            stateManager.ui().liveFeedTimings[chatIdRef.current] = chatConfigRef.current.messages.map((_message) => {
                const delta = (1.0 + 3.0 * Math.random()) * 1000;
                totalTime += delta;
                return totalTime;
            })*/
        }
    }




    useIntervalWhen(
        () => {
            /*const timings = stateManager.ui().liveFeedTimings[chatIdRef.current];
            if (timings !== undefined) {
                const time = Date.now();
                var next = -1;
                for (let i = 0; i < timings.length; i++) {
                    if (time < timings[i]) {
                        next = i;
                        i = timings.length;
                    }
                }
                next = next === -1 ? timings.length - 1 : next;
                messageIndex.current = next;
                rcRef.current++;
                setRc(rcRef.current);*/

            const now = Date.now();
            if (now > showNext.current) {
                showNext.current = Date.now() + (atBottom.current ? (1.0 + 3.0 * Math.random()) * 1000 : (0.5 + 1.0 * Math.random()) * 1000);
                if (messageIndex.current < (chatConfigRef.current.messages.length - 1)) {
                    messageIndex.current++;
                    stateManager.ui().liveFeedTimings[chatIdRef.current] = { index: messageIndex.current, at: now };
                }

                rcRef.current++;
                setRc(rcRef.current);
            }

            /*//console.log("paused : " + paused + " tick : " + tickCounter.current);
            if (messageComponents.current.length > 0) {
                messageIndex.current = next;
                if (messageIndex.current < messageTranslations.current.length) {
                    currentOffset.current = messageTranslations.current[messageIndex.current];
                    if (stackElementRef.current !== null)
                        stackElementRef.current.style.top = -currentOffset.current + 'px';
                }
                else
                {
                    currentOffset.current = messageTranslations.current[messageTranslations.current.length -1];
                    if (stackElementRef.current !== null)
                        stackElementRef.current.style.top = -currentOffset.current + 'px';
                }
            }
        }*/
        }, 100, true);

    if (messageIndex.current > (messageComponents.current.length - 1) ) {
        for (let a = messageComponents.current.length; a <= messageIndex.current; a++) {
            const component = RenderMessageForFeed(chatConfigRef.current.messages[a], uiConfig.fanboxColor('darkGray'), uiConfig.fontBase, currentUser, a, uiConfig.showEventOverlay);
            messageComponents.current.push(component)
        }
    }


    //var doRender = false; forceRender.current;
    //if (forceRender.current)
    //  forceRender.current = false;

    /* if ((messageComponents.current.length === 0) && (chatConfigRef.current.messages.length === 0)) {
         console.log("LiveMessageFeed: Initialised with empty config.");
         if (userMessageHandler !== undefined)
             userMessageHandler(_userMessageHandler);
         if (positionNotifier !== undefined)
             positionNotifier(_positionNotifier);
     }
     else if ((messageComponents.current.length === 0) && (chatConfigRef.current.messages.length > 0)) {
         //doRender = true;
         messageIndex.current = 0;
         messageListId.current = chatConfigRef.current.messages[0].itemId;
         messageComponents.current = Array<React.ReactElement>();
         console.log("LiveMessageFeed: Initialised with " + chatConfigRef.current.messages.length + " messages");
         if (userMessageHandler !== undefined)
             userMessageHandler(_userMessageHandler);
         if (positionNotifier !== undefined)
             positionNotifier(_positionNotifier);
     }
     else if (chatConfigRef.current.messages.length === 0) {
         console.log("LiveMessageFeed: Empty config.messages detected and executed");
         messageListId.current = '';
         //doRender = true;
         messageIndex.current = 0;
         messageComponents.current = Array<React.ReactElement>();
         if (userMessageHandler !== undefined)
             userMessageHandler(_userMessageHandler);
         if (positionNotifier !== undefined)
             positionNotifier(_positionNotifier);
    
     }
     else {
         if (chatConfigRef.current.messages[0].itemId !== messageListId.current) {
    
             messageIndex.current = 0;
             messageListId.current = chatConfigRef.current.messages[0].itemId;
             //doRender = true;
             messageComponents.current = Array<React.ReactElement>();
    
             console.log("LiveMessageFeed: Change of messages to " + chatConfigRef.current.messages.length + " messages");
             if (userMessageHandler !== undefined)
                 userMessageHandler(_userMessageHandler);
             if (positionNotifier !== undefined)
                 positionNotifier(_positionNotifier);
    
         }
     }*/




    /* if (doRender) {
         //console.log("Rendering messages in live feed : messages.length " + messages.length);
         if(stateManager.ui().liveFeedTimings[chatIdRef.current] === undefined)
         {
             const timings = Array<number>();
             var previousTime = Date.now() + 6000;
             timings.push(previousTime);
             for(let i = 1; i < chatConfigRef.current.messages.length; i++)
             {
                 const delta = (2.0 + 3.0 * Math.random()) * 1000;
                 previousTime += delta;
                 timings.push(previousTime);
             }
             stateManager.ui().liveFeedTimings[chatIdRef.current] = timings;
         }
         messageComponents.current = renderMessages(chatConfigRef.current, background, fontBase, currentUser, showSignIn);
         messageTranslations.current = [];
     }*/

    useEffect(() => {
        // if (messageTranslations.current.length === 0) {
        //    messageTranslations.current = getTranslationsFor(chatConfigRef.current.messages, height);
        //}
        //return ()=> { stateManager.ui().liveFeedTimings[chatIdRef.current] = undefined};
        const totalHeight = getTotalHeight(messageComponents.current);
        const shift = totalHeight - height > 0 ? totalHeight - height : 0;
        if (shift > 0)
            atBottom.current = true;
        if (stackElementRef.current !== null)
            stackElementRef.current.style.top = -shift + 'px';
    });


    return (
        <div style={{
            position: "relative",

            overflow: 'clip',
            transition: 'top 0.5s',
            transitionTimingFunction: 'ease-in-out',
            height: height + 'px',
            minHeight: height + 'px',
            maxHeight: height + 'px',
            width: uiConfig.width + 'px',
            minWidth: uiConfig.width + 'px',
            maxWidth: uiConfig.width + 'px',
            backgroundColor: uiConfig.fanboxColor('darkGray')
        }} key={"LiveMessageFeed-Display-InnerDiv"}>

            <div key={"LiveMessageDeed-Display-Stack"} ref={stackElementRef} style={{ display: 'flex', flexDirection: 'column', position: 'absolute', top: '0px', transition: 'top 0.5s', transitionTimingFunction: 'ease-in-out' }}>
                {(messageComponents.current.length === 0) && <span style={{ fontSize: uiConfig.fontBase * 2, width: "100%", textAlign: "left", paddingLeft: uiConfig.fontBase + "px", backgroundColor: "black", color: "white" }} key="LiveMessageFeed-NoMessages-Message"> There are no messages to display</span>}
                {messageComponents.current.map((item) => { return item; })}
            </div>
        </div>
    );


}